<template>

  <v-tabs v-model="tab">
    <v-tab v-for="(item, i) in items"
           :key="item.tab"
           @click="tabClick(i)">
      {{ item.tab }}
    </v-tab>
  </v-tabs>

</template>

<script>
  export default {
    name: "NotePreviewTabs",
    data () {
      return {
        tab: 0,
        items: [
          { tab: 'Recent' },
          { tab: 'Pinned' }
        ],
      }
    },
    methods: {
      tabClick(tab) {
        this.$emit('tabClick', tab);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .v-tabs {
    width: 140px;
    position: absolute;
    top: 7px;
    @include i-position-mirror(right, 0);
  }

  ::v-deep .v-tabs-bar {
    height: 30px;
  }

  .v-tab {
    padding: 0;
    text-transform: none;
    letter-spacing: normal;
    font-size: inherit;
    min-width: 60px;

    &--active {
      color: black;
    }
  }

  ::v-deep .v-tabs-slider {
    background-color: $brand_secondary_color;
  }

</style>
